// extracted by mini-css-extract-plugin
export default {"emailInput":"forgotPinForm_emailInput__20Efa","pinLabel":"forgotPinForm_pinLabel__RwbnQ","success":"forgotPinForm_success__ELUr8","linkBtn":"forgotPinForm_linkBtn__r3pAm"};